import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  return (
    <div className="home">
      <div className="home-header">
        <h1 className="home-title">🏌️ MisGolpes</h1>
        <p className="home-subtitle">Contador de golpes para golf</p>
      </div>

      <div className="container">
        <div className="home-content fade-in">
          <div className="card home-card">
            <div className="home-icon">⛳</div>
            <h2>Bienvenido</h2>
            <p>Lleva el control de tus golpes de manera simple y eficiente mientras juegas golf con tus amigos.</p>
          </div>

          <div className="home-buttons">
            <Link to="/crear" className="btn btn-primary btn-full btn-large">
              Crear Nueva Partida
            </Link>

            <Link to="/unirse" className="btn btn-secondary btn-full btn-large">
              Unirse a Partida
            </Link>
          </div>

          <div className="home-features">
            <div className="feature">
              <div className="feature-icon">👥</div>
              <div className="feature-text">
                <h3>Juega con amigos</h3>
                <p>Hasta 5 jugadores por partida</p>
              </div>
            </div>

            <div className="feature">
              <div className="feature-icon">📊</div>
              <div className="feature-text">
                <h3>Ranking en vivo</h3>
                <p>Ve tu posición en tiempo real</p>
              </div>
            </div>

            <div className="feature">
              <div className="feature-icon">📱</div>
              <div className="feature-text">
                <h3>Optimizado móvil</h3>
                <p>Diseñado para usar en el campo</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
